import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { AdministratorConfigStackParamList } from './AdministrationConfigStackParamList'
import {
  ACApprovalWorkflow,
  ACEditMetricList,
  ACMetricHistoryDetail,
  ACViewMetricList
} from './administration-config-screen'
import { pipe } from 'fp-ts/lib/function'
import { ErrorHandling, RBAC } from '@pulseops/common'
import { AdministrationConfigContext } from './AdministrationConfigContext'

const ConfigStack = createStackNavigator<AdministratorConfigStackParamList>()

export const AdministrationConfigStack = () => {
  const userPermissions: string[] = pipe(RBAC.permissionWithNoCache, ErrorHandling.runDidMount([]))
  return (
    <AdministrationConfigContext.Provider value={{ userPermissions: userPermissions }}>
      <ConfigStack.Navigator initialRouteName='ACViewMetricList' screenOptions={{ headerShown: false }}>
        <ConfigStack.Screen name="ACViewMetricList" component={ACViewMetricList}></ConfigStack.Screen>
        <ConfigStack.Screen name="ACMetricHistoryDetail" component={ACMetricHistoryDetail}></ConfigStack.Screen>
        <ConfigStack.Screen name="ACApprovalWorkflow" component={ACApprovalWorkflow}></ConfigStack.Screen>
        <ConfigStack.Screen name="ACEditMetricList" component={ACEditMetricList}></ConfigStack.Screen>
      </ConfigStack.Navigator>
    </AdministrationConfigContext.Provider>
  )
}
